import Vue from 'vue'
import Vuex from 'vuex'

import modulePlot from './modules/plot'
import moduleIcons from './modules/icons'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    plotTypeLoc: {
      forestPlot: '01',
      eventPlot: '02'
    },
    plot_type: {
      forest: {
        id: '01',
        label: 'forest'
      },
      pastures: {
        id: '02',
        label: 'pastures'
      },
      shrubs: {
        id: '03',
        label: 'shrubs'
      },
      nonwood: {
        id: '04',
        label: 'nonwood'
      }
    },
    event_type: {
      fire: {
        id: '01',
        label: 'fire'
      },
      erosion: {
        id: '02',
        label: 'erosion'
      },
      other: {
        id: '03',
        label: 'other'
      },
      illegal_cut: {
        id: '04',
        label: 'illegal-cut'
      }
    },
    endangered_type: {
      animals: '01',
      plants: '02'
    }
  },
  getters: {
    plotTypeLabel: (state) => (id) => {
      for (let plotType of Object.keys(state.plot_type)) {
        let type = state.plot_type[plotType]
        if (type.id === id) {
          return type.label
        }
      }
    },

    eventTypeLabel: (state) => (id) => {
      for (let eventType of Object.keys(state.event_type)) {
        let type = state.event_type[eventType]
        if (type.id === id) {
          return type.label
        }
      }
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    plot: modulePlot,
    icons: moduleIcons
  }
})
